import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useRecoilState, useRecoilValue } from 'recoil';
import * as AppState from '../../../../AppState';
import DropdownButton from '../../../Shared/DropdownButton';
import SortPropertyCards from './SortPropertyCards';

import './SortPropertyCardsDropdown.scss';


const SortPropertyCardsDropdown = (props: { id: string, fullWidth?: boolean, buttonClass?: string, wrapperClass?: string}) => {
	const gsSearchSort = useRecoilValue(AppState.gsPropertyListSort);
	const [gsPropertyListSortFilterApplied, setGsPropertyListSortFilterApplied] = useRecoilState(AppState.gsPropertyListSortFilterApplied);

	useEffect(() => {
		if (gsSearchSort !== 0) {
			setGsPropertyListSortFilterApplied(true);
		} else setGsPropertyListSortFilterApplied(false);
	}, [gsSearchSort, setGsPropertyListSortFilterApplied]);

	return (
		<DropdownButton
			fullWidth={props.fullWidth}
			defaultValue={
				gsSearchSort === 0 ? (
					'Default'
				) : gsSearchSort === 1 ?
					'Newest' : gsSearchSort === 2 ? (
						'Price Desc.'
					) : 'Price Asc.'
			}
			color='gray'
			variant='outline'
			id={props.id}
			wrapperClass={props.wrapperClass}
			className={classNames(
				(gsPropertyListSortFilterApplied
					? 'cc-btn--secondary homesearch-filters__cc-btn--active'
					: 'cc-btn--gray'),
				props.buttonClass && props.buttonClass,
				'sort-property-cards__dropdown cc-btn cc-btn--outline cc-btn--reset-text justify-content-center text-capitalize cc-btn--navbar homesearch-filters__cc-btn--sort')}
			options={ <SortPropertyCards /> }
		/>
	);
};

export default SortPropertyCardsDropdown;
